import { lazy, Suspense } from 'react';
import { Navigate, Outlet, useRoutes } from 'react-router-dom';
// layouts
import MainLayout from 'src/layouts/main';
// config
// import { PATH_AFTER_LOGIN } from 'src/config-global';
//
import { admindashboardRoutes } from './admin-dashboard';
import { authRoutes } from './auth';
import { authDemoRoutes } from './auth-demo';
import { dashboardRoutes } from './dashboard';
import { HomePage, mainRoutes } from './main';
import { superadmindashboardRoutes } from './superadmin-dashboard';

import { SplashScreen } from 'src/components/loading-screen';
import Privacy from 'src/pages/privacy-policy';
import Support from 'src/pages/terms-and-conditions';
import { componentsRoutes } from './components';
const JwtLoginPage = lazy(() => import('src/pages/auth/jwt/login'));

// ----------------------------------------------------------------------

export default function Router() {
  return useRoutes([
    // SET INDEX PAGE WITH SKIP HOME PAGE
    // {
    //   path: '/',
    //   element: <Navigate to={PATH_AFTER_LOGIN} replace />,
    // },

    // ----------------------------------------------------------------------

    // SET INDEX PAGE WITH HOME PAGE
    // {
    //   path: '/',
    //   element: (
    //     <GuestGuard>
    //       {/* <AuthClassicLayout>
    //         <JwtLoginPage />
    //       </AuthClassicLayout> */}
    //       <NewLoginPage />
    //     </GuestGuard>
    //   ),
    // },
    {
      path: '/',
      element: (
        <MainLayout>
          <Suspense fallback={<SplashScreen />}>
            <Outlet />
          </Suspense>
        </MainLayout>
      ),
      children: [
        {
          index: true,
          element: <HomePage />
        },
        {
          path: '/privacy',
          element: <Privacy />
        },
        {
          path: "/support",
          element: <Support />
        },
      ]
    },


    // Auth routes
    ...authRoutes,
    ...authDemoRoutes,
    //  Dashboard routes
    ...dashboardRoutes,

    //super-admin dashboard
    ...superadmindashboardRoutes,

    //user-dashboard
    ...admindashboardRoutes,

    // Main routes
    ...mainRoutes,

    // Components routes
    ...componentsRoutes,

    // No match 404
    { path: '*', element: <Navigate to="/404" replace /> },
  ]);
}
